// src/student/services/studentApi.js
import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (typeof import.meta !== "undefined" && import.meta.env?.VITE_API_URL) ||
  "http://localhost:5001/api";

const studentApi = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// Attach student token if stored
studentApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("selvas_student_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response error handler
studentApi.interceptors.response.use(
  (response) => response,
  (error) => {
    const message =
      error.response?.data?.message || error.message || "An error occurred with the server.";
    return Promise.reject(new Error(message));
  }
);

export const studentPortalAPI = {
  // Auth
  register: async (data) => {
    const res = await studentApi.post("/students/register", data);
    return res.data;
  },
  login: async (email, password) => {
    const res = await studentApi.post("/students/login", { email, password });
    return res.data;
  },
  lmsLogin: async (email, password) => {
    const res = await studentApi.post("/students/lms-login", { email, password });
    return res.data;
  },
  forgotPassword: async (email) => {
    const res = await studentApi.post("/students/forgot-password", { email });
    return res.data;
  },
  getProfile: async () => {
    const res = await studentApi.get("/students/profile");
    return res.data;
  },
  updateProfile: async (data) => {
    const res = await studentApi.put("/students/profile", data);
    return res.data;
  },

  // Content
  getDailyCA: async (params = {}) => {
    const res = await studentApi.get("/students/daily-ca", { params });
    return res.data;
  },
  getMonthlyCA: async (params = {}) => {
    const res = await studentApi.get("/students/monthly-ca", { params });
    return res.data;
  },

  // Prelims Tests
  getPublishedTests: async () => {
    const res = await studentApi.get("/students/published-tests");
    return res.data;
  },
  getTestById: async (id) => {
    const res = await studentApi.get(`/students/tests/${id}`);
    return res.data;
  },
  submitTestAttempt: async (testId, payload) => {
    const res = await studentApi.post(`/students/tests/${testId}/submit`, payload);
    return res.data;
  },

  // Mains Initiatives
  getPublishedInitiatives: async () => {
    const res = await studentApi.get("/students/published-initiatives");
    return res.data;
  },
  getInitiativeById: async (id) => {
    const res = await studentApi.get(`/students/mains/${id}`);
    return res.data;
  },
  submitMainsAnswer: async (initiativeId, formData) => {
    const res = await studentApi.post(`/students/mains/${initiativeId}/submit`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  },

  // Results
  getMyResults: async (email) => {
    const res = await studentApi.get("/students/my-results", {
      params: email ? { email } : {},
    });
    return res.data;
  },
};

export default studentPortalAPI;
